import { FC } from "react";
import { CustomLabel } from "types/CustomLabel";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

interface CustomLabelListProps {
  customLabels: CustomLabel[];
}

export const CustomLabelList: FC<CustomLabelListProps> = ({ customLabels }) => {
  const sorted = [...customLabels].sort((a, b) => a.index - b.index);
  return (
    <TableContainer component={Paper} variant="outlined" sx={{ maxWidth: 560 }}>
      <Table size="small" aria-label="custom labels table">
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: "600" }}>Index</TableCell>
            <TableCell sx={{ fontWeight: "600" }}>Label</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.map((customLabel) => (
            <TableRow key={customLabel.custom_label_id} hover>
              <TableCell width={80}>{customLabel.index}</TableCell>
              <TableCell>{customLabel.label}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
